import { useCallback, useEffect } from "react";
import { isFunc } from "@insightfulscience/shared-utils/fn";
import HotKeyListener from "./hot-key-listener";

export * from "./keys";

const GLOBAL_LISTENER_ID = "IS/HOTKEY_LISTENER";
global[GLOBAL_LISTENER_ID] = global[GLOBAL_LISTENER_ID] ?? HotKeyListener();
const globalKeyListener = global[GLOBAL_LISTENER_ID];

function useHotKey(keyPattern, callback, dependencies) {
	const { key, altKey = false, ctrlKey = false, shiftKey = false } = keyPattern;

	const handler = useCallback(
		event => (isFunc(callback) ? callback(event) : undefined), //
		[key, altKey, ctrlKey, shiftKey, ...dependencies],
	);

	useEffect(
		() => globalKeyListener.addHandler(keyPattern, handler), //
		[handler],
	);
}

export default useHotKey;
